import {BridgeAdUnitDemandPartnerLine} from './bridge-ad-unit-demand-partner-line.model';
export class BridgeAdUnitDemandPartnerResponse {
  numTotal = 0;
  numPending = 0;
  numRejected = 0;
  numApproved = 0;
  _numPendingPct = 0;
  _numApprovedPct = 0;
  _numRejectedPct = 0;
  adUnits: BridgeAdUnitDemandPartnerLine[];
}
